export default {
  'stone.establishment.notification.success': 'Success',

  'stone.establishment.create.notification.successDescription':
    'Establishment created successfully!',
  'stone.establishment.update.notification.successDescription':
    'Establishment reactivated successfully!',

  'stone.establishment.remove.notification.successDescription':
    'Establishment deactivated successfully!',

  'stone.pos.notification.success': 'Success',

  'stone.pos.create.notification.successDescription':
    'Configurations saved successfully!',
};
